module.exports = __webpack_public_path__ + "img/md-computer.d4ac5ee0.png";